v<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="'View Equipment Type :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link to="/equipment">
                            <i class="fa fa-truck"></i> Equipment
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link to="/equipment#types">
                            Types
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">{{ equipment_type.equipment_type_name }}</li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-lg-8 col-12">
                    <div class="card">
                        <div class="card-header">
                            <strong>{{ equipment_type.equipment_type_name }}</strong>
                            <div v-if="this.$store.state.user.is_admin" class="float-sm-right float-none d-print-none d-block d-sm-inline-block mt-2 mt-sm-0">
                                <router-link :to="`/equipment/types/edit/${equipment_type_id}`" title="Edit Equipment Type" class="btn btn-sm btn-light">
                                    <i class="fa fa-edit"></i> Edit
                                </router-link>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row mb-2">
                                <label class="col-md-4 text-md-right text-muted">Equipment Type Name:</label>
                                <div class="col-md-8">
                                    {{ equipment_type.equipment_type_name }}
                                </div>
                            </div>
                            <div class="row mb-2">
                                <label class="col-md-4 text-md-right text-muted">Active:</label>
                                <div class="col-md-8">
                                    <label class="badge badge-success" v-if="equipment_type.is_active == 1">Active</label>
                                    <label class="badge badge-warning" v-else>Inactive</label>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <label class="col-md-4 text-md-right text-muted">Default Equipment Usage Type:</label>
                                <div class="col-md-8">
                                    {{ equipment_type.equipment_usage_type_name || '' }}
                                </div>
                            </div>
                            <div class="row mb-2">
                                <label class="col-md-4 text-md-right text-muted">Calibration Valid For (Days):</label>
                                <div class="col-md-8">
                                    {{ equipment_type.days_calibration_valid_for ? equipment_type.days_calibration_valid_for + ' Days' : '' }}
                                </div>
                            </div>
                            <div class="row mb-2">
                                <label class="col-md-4 text-md-right text-muted">
                                    Require Inspection on Check In:
                                    <i class="fa fa-question-circle" title="When checking in equipment, an inspection will be required. This can either be a MeritEHS inspection or a file uploaded."></i>
                                </label>
                                <div class="col-md-8">
                                    <label class="badge badge-success" v-if="equipment_type.require_inspection == 1">Yes</label>
                                    <label class="badge badge-warning" v-else>No</label>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <label class="col-md-4 text-md-right text-muted">
                                    Require Inspection on Issuing/Check Out:
                                    <i class="fa fa-question-circle" title="When checking out equipment, an inspection will be required. This can either be a MeritEHS inspection or a file uploaded."></i>
                                </label>
                                <div class="col-md-8">
                                    <label class="badge badge-success" v-if="equipment_type.require_insp_on_checkout == 1">Yes</label>
                                    <label class="badge badge-warning" v-else>No</label>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <label class="col-md-4 text-md-right text-muted">
                                    Prevent Checkout w/ Open Corrective Actions
                                    <i class="fa fa-question-circle" title="When checking out equipment, if the equipment has any Open corrective actions on inspections, MeritEHS will not allow the user to check out the item."></i>
                                </label>
                                <div class="col-md-8">
                                    <label class="badge badge-danger" v-if="equipment_type.restrict_checkout_w_open_ca == 1">Yes</label>
                                    <label class="badge badge-default" v-else>No</label>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <label class="col-md-4 text-md-right text-muted">
                                    Require Jobsite When Issuing:
                                    <i class="fa fa-question-circle" title="When issuing the equipment, a Jobsite will be required if this setting is turned on"></i>
                                </label>
                                <div class="col-md-8">
                                    <label class="badge badge-success" v-if="equipment_type.require_tracking_jobsite == 1">Yes</label>
                                    <label class="badge badge-warning" v-else>No</label>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-md-4 text-md-right text-muted">
                                    <label>
                                        Use current value instead of difference when inputting usage:
                                        <i class="fa fa-question-circle" title="For example, instead of saying you added 10,000 miles to a vehicle, you'd input 60,000 (the current odometer reading)"></i>
                                    </label>
                                </div>
                                <div class="col-md-8">
                                    <label class="badge badge-success" v-if="equipment_type.use_absolute_usage == 1">Yes</label>
                                    <label class="badge badge-warning" v-else>No</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card mt-4">
                        <div class="card-header"><strong>Custom Fields ({{ custom_fields.length }})</strong></div>
                        <div class="card-body">
                            <div v-for="field in custom_fields" class="mb-2">
                                {{ field.label }}
                                <ul>
                                    <li>Type: <strong>{{ field.name }}</strong></li>
                                    <li v-if="field.name === 'Date'">Past or Future: <strong v-if="field.past_or_future">{{ field.past_or_future | capitalize }}</strong><span v-else>--</span></li>
                                    <li>Required: <span v-if="field.is_required" class="badge badge-success">Yes</span><span v-else class="badge badge-secondary">No</span></li>
                                    <li v-if="field.name === 'Date'">
                                        Enable Date Alerts <i class="fa fa-question-circle" title="If enabled, this field can be used for Equipment Date Alerts and will be pulled into the Equipment Dates section on the main equipment list."></i>:
                                        <span v-if="field.use_for_alerts" class="badge badge-success">Yes</span><span v-else class="badge badge-secondary">No</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="card mt-4">
                        <div class="card-header"><strong>Photos</strong></div>
                        <div class="card-body">
                            <file-list :files="files" :canEdit="false" />
                        </div>
                    </div>
                </div>
            </div>

            <b-tabs class="nav-tabs-top mt-4">
                <b-tab active>
                    <template slot='title'>
                        <i class="fa fa-truck"></i> Equipment <template v-if="equipment_count">({{ equipment_count }})</template>
                    </template>
                    <b-card-body>
                        <equipment-list assetType="EquipmentType" :assetId="equipment_type_id" @equipmentListCount="setEquipmentCount" />
                    </b-card-body>
                </b-tab>
                <b-tab>
                    <template slot='title'>
                        <i class="fa fa-envelope"></i> Date Alerts ({{ rules.length }})
                    </template>
                    <b-card-body>
                        <template v-if="rules.length > 0">
                        <v-client-table ref="emailRulesTable" :columns="columns" :options="options" :data="rules">

                            <router-link slot="alert_name" slot-scope="props" :to="`/admin/equipment-alerts/view/${props.row.id}`" title="View Date Alert">
                                {{ props.row.alert_name }}
                            </router-link>

                            <template slot="is_active" slot-scope="props">
                                <label v-if="props.row.is_active == 1" class="badge badge-success">Active</label>
                                <label v-if="props.row.is_active == 0" class="badge badge-warning">Inactive</label>
                            </template>

                            <template slot="child_row" slot-scope="props">
                                <div class="mb-3">
                                    <span class="font-weight-bold">Description:</span><br>
                                    <div v-html="props.row.description"></div>
                                </div>
                                <div class="row" style="margin-right: -0.625rem; margin-left: -0.625rem;">
                                    <div class="col-md-6 col-12 mb-md-0 mb-3">
                                        <span class="font-weight-bold">Conditions</span><br>
                                        <li v-for="(cond, key) in props.row.conditions">
                                            <strong>WHEN </strong>{{cond.field_type}} "{{cond.field_value_formatted}}"<strong> IS </strong>{{cond.cond_value_formatted}}<strong> DAYS </strong>{{cond.cond_sign}}
                                        </li>
                                    </div>
                                    <div class="col-md-6 col-12 mb-md-0 mb-3">
                                        <span class="font-weight-bold">Recipients</span><br>
                                        Send Email To:
                                        <ol>
                                            <li v-for="(recip, key) in props.row.recipients">
                                                {{ recip.target_type }} -
                                                <template v-if="recip.target_type == 'Employee' || recip.target_type == 'User'">
                                                    {{ recip.target_label.FirstName }} {{ recip.target_label.LastName }}
                                                </template>
                                                <template v-else>{{ recip.target_label }}</template>
                                            </li>
                                        </ol>
                                    </div>
                                </div>
                            </template>
                        </v-client-table>
                        </template>
                    </b-card-body>
                </b-tab>
            </b-tabs>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: false,
                equipment_count: null,
                equipment_type_id: this.$route.params.id,
                equipment_type: {},
                custom_fields: [],
                files: [],
                rules: [],
                columns: ['alert_name', 'is_active'],
                options: {
                    columnsDropdown: false,
                    filterable: false,
                    //perPage: -1,
                    headings: {
                        alert_name: 'Name',
                        is_active: 'Status',
                    },
                    orderBy: {
                        ascending: false,
                        column: 'equip_alerts.id',
                    },
                },

            }
        },

        methods: {
            getEquipmentType: function() {
                //Loading
                this.loading = true;

                //Get the data
                this.$http
                    .get(`equipment/types/${this.equipment_type_id}`)
                    .then(response => {
                        //Set all the data
                        this.equipment_type = response.data.type;
                        this.rules = response.data.rules;
                        this.files = this.equipment_type.files;

                        //Check for the Custom Fields
                        if(this.equipment_type.custom_fields != null)
                        {
                            //Set it
                            this.custom_fields = JSON.parse(this.equipment_type.custom_fields);
                        }

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            setEquipmentCount(count){
                //Set it
                this.equipment_count = count;
            },
        },

        mounted() {
            //Check it
            if(this.equipment_type_id)
            {
                //Get the incidents
                this.getEquipmentType();
            }
        }
    }
</script>
